<section class="seller-link-data">
  <p class="h5">Link de Pagamento (Cartão)</p>

  @if (paymentLinkUrl) {
    @if (detailsSuppressed) {
      <p class="text-muted" role="status">
        Cobrança ativa. Abra o painel de cobrança para ver o link de pagamento e o status do pagamento.
      </p>
    } @else {
      <div class="status-payment mb-3">
        <div
          class="alert"
          [ngClass]="{
            'alert-info': statusPaymentPix === 'AGUARDANDO PAGAMENTO',
            'alert-success': statusPaymentPix === 'PAGO',
            'alert-danger': statusPaymentPix === 'FALHOU',
          }">
          <span>{{ statusPaymentPix }}</span>
          <small class="d-block mt-2">
            <i
              class="fas fa-wifi me-1"
              [class.text-success]="isWebSocketConnected"
              [class.text-muted]="!isWebSocketConnected"></i>
            {{
              isWebSocketConnected ? "Conectado - Aguardando confirmação em tempo real" : "Verificando periodicamente"
            }}
          </small>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label" for="sellerPaymentLink">Link de pagamento</label>
        <div class="link-copy-row">
          <input id="sellerPaymentLink" class="form-control" type="text" [value]="paymentLinkUrl" readonly />
          <app-button (btnClick)="copyLink()">
            <i class="fas fa-copy me-2"></i>
            Copiar Link
          </app-button>
        </div>
      </div>
    }
  } @else {
    <app-button (btnClick)="generateLinkClick.emit()" [disabled]="loading" styleType="success">
      {{ loading ? "Gerando link..." : "Gerar Link de Pagamento" }}
    </app-button>
  }
</section>
